import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import hasClass from '../../general/class/hasClass';
import removeClass from '../../general/class/removeClass';
import toggleClass from '../../general/class/toggleClass';

// ----------------------------------------------------------------------------

function start(element: HTMLTableElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        select: {
            style: 'single',
        },
        className: 'selected',
        eventName: 'click',
        selector: 'tbody > tr',
        toggleable: true,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create event
    (window as any).$(element).on(defConfig.eventName, defConfig.selector, function (this: any, evt: any): any {
        const elTable = this.closest('table');

        if (!(elTable instanceof HTMLTableElement)) {
            return;
        }

        // If there is table empty
        if (hasClass(this, 'table-empty') || this.querySelector('.table-empty')) {
            return;
        }

        // If using function select
        if (typeof defConfig.fnSelect === 'function') {
            const res = defConfig.fnSelect.call(this, evt);

            // If result is true
            if (res === true) {
                return;
            }
        }

        // If using single
        if (defConfig.select.style === 'single') {
            const isSelected = hasClass(this, defConfig.className);

            elTable.querySelectorAll(defConfig.selector).forEach(function (elRow): void {
                if (elRow instanceof HTMLElement && hasClass(elRow, defConfig.className)) {
                    removeClass(elRow, defConfig.className);
                }
            });

            if (!isSelected || defConfig.toggleable !== true) {
                addClass(this, defConfig.className);
            }
        }
        // If using multi
        else if (defConfig.select.style === 'multi') {
            if (defConfig.toggleable === true) {
                toggleClass(this, defConfig.className);
            } else {
                addClass(this, defConfig.className);
            }
        }

        // If using function selected
        if (typeof defConfig.fnSelected === 'function') {
            defConfig.fnSelected.call(this, evt);
        }
    });
}

// ----------------------------------------------------------------------------

export { start };
